module.exports = {
  VectorShape: {
    PluginName: "Şekil",
  },
};
